import React, { useState, useEffect } from 'react';
import { Alert } from 'reactstrap';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsaMemberInfo$ } from 'services/subjects';
import { AUDITEVENTTYPE } from 'services/trackService';
import { sendCustomEvent } from 'common/utility';
import { useNavigate } from 'react-router-dom';
import withMemberPortalConfigData from 'hoc/withMemberPortalConfigData';
import { MemberPortalConfig, defaultJsaBannerConfiguration } from 'interfaces/MemberPortalConfig';

interface Props {
    member: any;
    displayJSAAlert: boolean;
    memberPortalConfig: MemberPortalConfig;
}
const JsaNotification = ({ member, memberPortalConfig}: Props) => {
    const jsaBanner = memberPortalConfig.jsaBanner || defaultJsaBannerConfiguration;
    const SPLIT_TEXT = 'Click here'
    const [visible, setVisible] = useState(false);
    const fromJSAAlertFlag = true;
    const navigate = useNavigate();
    const secondParagraphList = jsaBanner.secondParagraph.split(SPLIT_TEXT);
    useEffect(() => {
        const sub = jsaMemberInfo$.subscribe((display) => {
            if (!display) return;
            return setVisible(display.displayAlert);
        });

        return () => {
            sub.unsubscribe();
        };
    }, []);

    if (!member) return <></>;

    return (
        <Alert isOpen={visible} color="success" style={{ marginTop: 16 }}>
            <div style={{ display: 'flex' }}>
                {' '}
                <p style={{ paddingRight: 10 }}>
                    <FontAwesomeIcon icon={faBell} aria-label="jsa-noti" />
                </p>
                <div>
                    <p style={{ fontWeight: 'bold' }}>{jsaBanner.title}</p>
                    <p>{jsaBanner.firstParagraph}</p>
                    <p style={{ fontWeight: 'bold' }}>
                       {secondParagraphList[0]}
                        <a
                            onClick={() => {
                                sendCustomEvent({
                                    eventType: AUDITEVENTTYPE.MemberPortalJSAAlert,
                                });
                                navigate(jsaBanner.redirectTo, {
                                    state: {
                                        data: fromJSAAlertFlag,
                                    },
                                });
                            }}
                            style={{
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                color: 'blue',
                            }}
                        >
                             {SPLIT_TEXT}
                        </a>{' '}
                        {secondParagraphList[1]}
                    </p>{' '}
                    <p>
                        {jsaBanner.thirdParagraph}
                    </p>
                </div>
            </div>
        </Alert>
    );
};

export default withMemberPortalConfigData(JsaNotification);
